import type { LabelVariant } from '../../../label/LabelVariant';
import { progressSuccess, progressDanger, labelWarningBg } from '../../../themes/colors';

export const RED_THRESHOLD = 40;

export const getProgressColor = (percent: number): string => {
	if (percent >= 100) return progressSuccess;
	if (percent < RED_THRESHOLD) return progressDanger;
	return labelWarningBg;
};

export const getVariantFromPercent = (percent: number): LabelVariant => {
	if (percent >= 100) return 'success';
	if (percent < RED_THRESHOLD) return 'critical';
	return 'warning';
};
